export interface Notification {
  id?: number;
  message: string;
  type: 'error' | 'info' | 'success' | 'warning';
}

export const NotificationTimeouts = {
  error: 4000,
  info: 2000,
  success: 1500,
  warning: 3000,
};
